import { ADD_ORDER_TO_CART, INIT_ORDER, INIT_DIALOG_LISTS, UPDATE_ITEM, CLEAR_ITEMS, TOGGLE_LIST_NAME_EDITING, } from './action-creators';
export default function (state, action) {
    if (!state) {
        state = {
            favorites: [],
            pantries: [],
            fromList: null,
            codes: [],
            order: [],
        };
    }
    switch (action.type) {
        case INIT_DIALOG_LISTS:
            return Object.assign(Object.assign({}, state), action.dialog);
        case INIT_ORDER:
            return Object.assign({}, state, {
                order: action.products.slice(0),
            });
        case ADD_ORDER_TO_CART:
            return Object.assign({}, state);
        case UPDATE_ITEM:
            return Object.assign({}, state, {
                order: state.order.findIndex(item => item.productId === action.productId) === -1
                    ? Object.assign([], state.order, state.order.concat([action.item]))
                    : state.order.map(i => i.productId === action.productId ? action.item : i),
            });
        case CLEAR_ITEMS:
            return Object.assign({}, state, { order: state.order.map(item => Object.assign({}, item, { quantity: 0 })) });
        case TOGGLE_LIST_NAME_EDITING:
        default:
            return state;
    }
}
